import { render, staticRenderFns } from "./hedgeManage.vue?vue&type=template&id=09580304&scoped=true&"
import script from "./hedgeManage.vue?vue&type=script&lang=js&"
export * from "./hedgeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09580304",
  null
  
)

export default component.exports